export default __webpack_public_path__ + "static/media/icon_phone.3a018e24.svg";